import Styles from './ProcessingContent.module.scss'
import { Spinner } from 'common/Spinner/Spinner'
import { Text } from 'blaze-ui/Text/Text'
import { ProcessingContentProps } from './Types'
import { DesignProcessingMessage } from './DesignPreview/DesignProcessingMessage'
import { useAbortMessage } from 'hooks/queries/chat/useAbortMessage'
import { Button } from 'blaze-ui/Button'

export const ProcessingContent = ({ content, message }: ProcessingContentProps) => {
  const { mutate: abortMessage } = useAbortMessage()

  const handleAbort = () => {
    abortMessage({ threadId: message.thread_id, id: message.id })
  }

  return (
    <>
      <div className={Styles.loading}>
        <div className={Styles.loadingContent}>
          <Spinner variant="blue" />
          <div className={Styles.loadingText}>
            <Text variant="secondary">{content.text || 'Reading your message...'}</Text>
          </div>
        </div>
        <Button variant="ghost" size="sm" onPress={handleAbort}>
          <Text variant="smallList">Cancel</Text>
        </Button>
      </div>
      {'tool' in content && content.tool === 'revise_design' && <DesignProcessingMessage content={content} />}
    </>
  )
}
